"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelPickerPopoverBody = exports.LabelPickerItem = exports.LabelPicker = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = require("prop-types");
var _Label = require("./Label");
var _ColorRotater = require("../ColorRotater");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledPopoverBody = (0, _styledComponents["default"])(_reactstrap.PopoverBody)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 16px 0;\n"])));
var LabelPickerStyledItem = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: 0 15px;\n  display: flex;\n  align-items: center;\n\n  margin-bottom: 6px;\n  min-width: 80px;\n  cursor: pointer;\n\n  input {\n    position: relative;\n    margin: 0;\n  }\n"])));
var LabelWrapper = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  margin-left: 8px;\n"])));
var LabelPickerWrapper = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: auto;\n  max-height: 200px;\n"])));
var LabelPicker = exports.LabelPicker = function LabelPicker(_ref) {
  var _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? [] : _ref$labels,
    _ref$selectedLabelIds = _ref.selectedLabelIds,
    selectedLabelIds = _ref$selectedLabelIds === void 0 ? [] : _ref$selectedLabelIds,
    onChange = _ref.onChange,
    onCreate = _ref.onCreate;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    popoverOpen = _useState2[0],
    setPopoverOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    createFormOpen = _useState4[0],
    setCreateFormOpen = _useState4[1];
  var togglePopover = function togglePopover() {
    setPopoverOpen(popoverOpen ? false : true);
  };
  var toggleForm = function toggleForm() {
    setCreateFormOpen(createFormOpen ? false : true);
  };
  return _react["default"].createElement("div", null, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    "data-testid": "labelPickerPlusIcon",
    id: "labelPicker",
    icon: _freeSolidSvgIcons.faPlusCircle,
    onClick: togglePopover
  }), _react["default"].createElement(_reactstrap.Popover, {
    trigger: "legacy",
    placement: "auto",
    isOpen: popoverOpen,
    target: "labelPicker",
    toggle: togglePopover
  }, _react["default"].createElement(LabelPickerPopoverBody, {
    createFormOpen: createFormOpen,
    toggleForm: toggleForm,
    labels: labels,
    onCreate: onCreate,
    onChange: onChange,
    selectedLabelIds: selectedLabelIds
  })));
};
LabelPicker.propTypes = {
  labels: _propTypes.PropTypes.array,
  selectedLabelIds: _propTypes.PropTypes.array,
  onChange: _propTypes.PropTypes.func.isRequired,
  onCreate: _propTypes.PropTypes.func.isRequired
};
var LabelPickerPopoverBody = exports.LabelPickerPopoverBody = function LabelPickerPopoverBody(_ref2) {
  var createFormOpen = _ref2.createFormOpen,
    toggleForm = _ref2.toggleForm,
    labels = _ref2.labels,
    selectedLabelIds = _ref2.selectedLabelIds,
    onCreate = _ref2.onCreate,
    onChange = _ref2.onChange;
  var labelItems = labels.map(function (l) {
    var checked = selectedLabelIds.indexOf(l._id) >= 0;
    return _react["default"].createElement(LabelPickerItem, {
      onClick: function onClick() {
        onChange(checked ? selectedLabelIds.filter(function (id) {
          return id !== l._id;
        }) : selectedLabelIds.concat(l._id));
      },
      key: "label-picker-".concat(l._id),
      checked: checked,
      label: l
    });
  });
  return _react["default"].createElement(StyledPopoverBody, null, !createFormOpen && _react["default"].createElement(CreateLabelButton, {
    onClick: toggleForm
  }), createFormOpen && _react["default"].createElement(CreateForm, {
    onCreate: onCreate,
    onCancel: toggleForm
  }), _react["default"].createElement(LabelPickerWrapper, null, labelItems));
};
LabelPickerPopoverBody.propTypes = {
  labels: _propTypes.PropTypes.array.isRequired,
  selectedLabelIds: _propTypes.PropTypes.array.isRequired,
  onChange: _propTypes.PropTypes.func.isRequired,
  onCreate: _propTypes.PropTypes.func.isRequired,
  toggleForm: _propTypes.PropTypes.func.isRequired,
  createFormOpen: _propTypes.PropTypes.bool.isRequired
};
var CreateLabelButtonWrapper = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  background-color: #F0F2F6;\n\n  padding: 4px 15px;\n  margin-bottom: 8px;\n\n  font-size: 12px;\n  font-weight: 400;\n  color: #444444;\n  cursor: pointer;\n\n  svg {\n    margin-right: 8px;\n  }\n"])));
var CreateLabelButton = function CreateLabelButton(_ref3) {
  var onClick = _ref3.onClick;
  return _react["default"].createElement(CreateLabelButtonWrapper, {
    onClick: onClick
  }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTag
  }), " Create new label");
};
var CreateNewWrapper = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  background: #F0F2F6;\n  padding: 8px 15px;\n  margin-bottom: 8px;\n"])));
var CreateNewLabel = _styledComponents["default"].label(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 16px;\n  font-weight: 500;\n  font-size: 14px;\n  color: #333333;\n"])));
var StyledInput = (0, _styledComponents["default"])(_reactstrap.Input)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 32px;\n  font-size: 14px;\n"])));
var ColorPickerWrapper = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  margin-top: 8px;\n  margin-bottom: 6px;\n"])));
var ColorLabel = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 14px;\n  line-height: 16px;\n  color: #767676;\n  width: 100%;\n  margin-bottom: 4px;\n  margin-top: 8px;\n"])));
var ButtonsWrapper = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: flex-end;\n\n  button {\n    font-size: 14px;\n    padding: 0 8px;\n    height: 33px;\n    border-radius: 5px;\n  }\n"])));
var CreateForm = function CreateForm(_ref4) {
  var onCreate = _ref4.onCreate,
    onCancel = _ref4.onCancel;
  var _useState5 = (0, _react.useState)(""),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    labelName = _useState6[0],
    setLabelName = _useState6[1];
  var _useState7 = (0, _react.useState)("#6B66F8"),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    color = _useState8[0],
    setColor = _useState8[1];
  return _react["default"].createElement(CreateNewWrapper, null, _react["default"].createElement(CreateNewLabel, null, "Label name"), _react["default"].createElement(StyledInput, {
    type: "text",
    value: labelName,
    placeholder: "New label name",
    onChange: function onChange(e) {
      return setLabelName(e.target.value);
    }
  }), _react["default"].createElement(ColorLabel, null, "Color"), _react["default"].createElement(ColorPickerWrapper, null, _react["default"].createElement(_ColorRotater.ColorRotater, {
    defaultValue: color,
    onChange: setColor
  }), _react["default"].createElement(_Label.Label, {
    text: "Label preview",
    color: color
  })), _react["default"].createElement(ButtonsWrapper, null, _react["default"].createElement(_reactstrap.Button, {
    color: "primary",
    onClick: function onClick() {
      onCreate({
        text: labelName,
        color: color
      });
    }
  }, "Create"), _react["default"].createElement(_reactstrap.Button, {
    color: "default",
    onClick: onCancel
  }, "Cancel")));
};
var LabelPickerItem = exports.LabelPickerItem = function LabelPickerItem(_ref5) {
  var label = _ref5.label,
    onClick = _ref5.onClick,
    checked = _ref5.checked;
  return _react["default"].createElement(LabelPickerStyledItem, {
    onClick: onClick
  }, _react["default"].createElement(_reactstrap.Input, {
    value: label.text,
    readOnly: true,
    type: "checkbox",
    id: "label-picker-check-".concat(label._id),
    checked: checked
  }), _react["default"].createElement(LabelWrapper, null, _react["default"].createElement(_Label.Label, label)));
};